import { LandingPage, paths } from 'frameworks_drivers/routes/index';

import React from 'react';
import { RouteObject } from 'react-router-dom';
import TOSPage from '../../presentation/pages/TOS/TOSPage';
import ReturnPolicyPage from '../../presentation/pages/ReturnPolicy/ReturnPolicyPage';
import DataProtection from '../../presentation/pages/DataProtection/DataProtection';
import CookieConsentPage from '../../presentation/pages/DataProtection/CookieConsentPage';
import DataProtectionPage from '../../presentation/pages/DataProtection/DataProtectionPage';

export const publicRoutes: RouteObject[] = [
  {
    path: paths.LandingPage,
    element: <LandingPage />
  },
  {
    path: paths.TOS,
    element: <TOSPage />
  },
  {
    path: paths.ReturnPolicy,
    element: <ReturnPolicyPage />
  },
  {
    path: paths.DataProtection,
    element: <DataProtection />,
    children: [
      {
        path: 'cookie-consent',
        element: <CookieConsentPage />
      },
      {
        path: '',
        element: <DataProtectionPage />
      }
    ]
  }
];
